module.exports = __webpack_public_path__ + "253bd8371566f352ee57535b6bd88b7f.fbx";